@if (controlInfo) {
    <eff-expansion-panel
        [contentTemplate]="content"
        [panelOpenState]="panelOpenState"
        [title]="
            controlInfo.SnapshotDate
                ? ('controls.effControlInfoBox.panelTitleAtDate'
                  | transloco: { date: (controlInfo.SnapshotDate | dateFormat) })
                : ('controls.effControlInfoBox.panelTitle' | transloco)
        "
        class="eff-details-panel"
        data-uiid="new-eff-upload-source-document-control-description-info-box"
    >
        <ng-template #content>
            <div class="rows-container">
                <div class="d-flex flex-row justify-content-between">
                    <eff-button
                        class="link-button"
                        icon="north_east_outlined"
                        size="medium-size"
                        iconPosition="right"
                        iconSize="small-size"
                        [text]="'controls.effControlInfoBox.openControl' | transloco"
                        data-uiid="new-eff-control-info-box-open-control-button"
                        (click)="openControl()"
                    ></eff-button>
                    <eff-button
                        class="link-button"
                        icon="north_east_outlined"
                        size="medium-size"
                        iconPosition="right"
                        iconSize="small-size"
                        [text]="'controls.effControlInfoBox.testplanOverview' | transloco"
                        data-uiid="new-eff-control-info-box-testplan-overview-button"
                        (click)="openEffOverview()"
                    ></eff-button>
                </div>
                <div class="row-container">
                    <div class="bold-text row-label">{{ 'controls.effControlInfoBox.id' | transloco }}</div>
                    <div class="regular-text">{{ controlInfo.ControlIdentifier }}</div>
                </div>

                <div class="row-container">
                    <div class="bold-text row-label">{{ 'controls.effControlInfoBox.controlName' | transloco }}</div>
                    <div class="regular-text">{{ controlInfo.ControlName }}</div>
                </div>

                <div class="row-container">
                    <div class="bold-text row-label">{{ 'controls.effControlInfoBox.controlFrequency' | transloco }}</div>
                    <div class="regular-text">{{ controlInfo.ControlFrequency }}</div>
                </div>

                <div class="row-container">
                    <div class="bold-text row-label">{{ 'controls.effControlInfoBox.executionMethod' | transloco }}</div>
                    <div class="regular-text">{{ controlInfo.ControlExecutionMethod }}</div>
                </div>

                <div class="bold-text row-label">{{ 'controls.effControlInfoBox.description' | transloco }}</div>
                <div
                    class="regular-text multiple-whitespaces"
                    [innerHTML]="controlInfo.ControlDescription"
                ></div>
            </div>
        </ng-template>
    </eff-expansion-panel>
}
